import {
  CashflowFiltersHeader,
  CategoryOrContactDropdown,
  IncomeExpenseTabs,
  PieChart,
  ReportsHeaderPrimaryRow,
  Tables,
  TotalIncomeAndExpense,
} from '@npco/component-mp-feature-cashflow-reporting-page'
import { Flex, PageTemplate } from '@npco/zeller-design-system'

import { MobileNavHeader } from 'components/Sidebar/components/MobileNavHeader/MobileNavHeader'

export const CashflowReporting = () => {
  return (
    <PageTemplate
      HeaderPrimaryRow={
        <PageTemplate.HeaderPrimaryRow>
          <ReportsHeaderPrimaryRow />
        </PageTemplate.HeaderPrimaryRow>
      }
      HeaderMobileRow={<MobileNavHeader />}
      HeaderSecondaryRow={<CashflowFiltersHeader />}
    >
      <TotalIncomeAndExpense />
      <CategoryOrContactDropdown />
      <IncomeExpenseTabs />
      <Flex>
        <Tables />
        <PieChart />
      </Flex>
    </PageTemplate>
  )
}
